<template>
  <div class="modal fade" id="couponModal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">設定優惠券</h4>
        </div>
        {{coupon}}
        <div class="modal-body" v-if="coupon.name">

        </div>
        <!--
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
          <button type="button" class="btn btn-success" @click="addNewCoupon" data-dismiss="modal">確定</button>
        </div>
        -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    coupon: Object
  },
  data () {
    return {
      newCouponType: '',
      orderType: [
        {label: '一般單', value: 1},
        {label: '團購單 - 團長', value: 2},
        {label: '團購單 - 團員', value: 3}
      ],
      delOption: {
        id: 'delModal',
        title: '刪除贈送優惠券',
        body: '刪除此優惠券，設定的內容將被刪除',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delCoupon'
          }
        ]
      }
    }
  },
  methods: {
    trigger (event) {
      if (event === 'delCoupon') {
        this.delCoupon()
      }
    },
    addNewCoupon () {
      var obj = {
        coupon_strategy: {},
        coupon_set_list: [
          {
            coupon_info: {
              set_name: '',
              set_description: '',
              name: '',
              description: '',
              remark: '',
              discount_type: 1,
              discount_value: '',
              price_type: 3,
              usage_store_config: {
                usage_store_type: 2, // 會被roleType限制
                usage_store_value: null,
                usage_method: 'order_store',
                manual_store_ids: [] // usage_method === manual 需要
              },
              time_config: {
                time_type: 'all_fixed',
                start_time: '',
                end_time: '',
                use_start_day: '',
                use_tolerance_day: ''
              },
              is_group_usage: 1,
              amount_unit: 1
            }
          }
        ]
      }
      if (this.newCouponType === 'SC00001') {
        obj.coupon_strategy = {
          rule_code: 'SC00001',
          name: '優惠券',
          description: '',
          limit: {
            min_amount: 1,
            min_money: '',
            order_method: '',
            orderMethod: '',
            order_types: [],
            orderTypes: [],
            delivery_types: [],
            deliveryTypes: []
          },
          setting: {
            one_max_amount: null,
            ratio: 1,
            lowest_unit_price: 0
          },
          store_exception_items: [
            {
              products: [],
              store_ids: []
            }
          ]
        }
      } else if (this.newCouponType === 'SC00002') {
        obj.coupon_strategy = {
          rule_code: 'SC00002',
          name: '優惠券',
          description: '',
          limit: {
            min_amount: 1,
            min_money: '',
            order_method: '',
            orderMethod: '',
            order_types: [],
            orderTypes: [],
            delivery_types: [],
            deliveryTypes: []
          },
          setting: {
            one_max_amount: null,
            ratio: 1,
            vendorCustomProductList: [],
            vendor_custom_product_list: []
          },
          store_exception_items: []
        }
      } else if (this.newCouponType === 'SC00003') {
        obj.coupon_strategy = {
          rule_code: 'SC00002',
          name: '優惠券',
          description: '',
          limit: {
            min_amount: 1,
            min_money: '',
            order_method: '',
            orderMethod: '',
            order_types: [],
            orderTypes: [],
            delivery_types: [],
            deliveryTypes: []
          },
          setting: {
            one_max_amount: null,
            ratio: 1,
            money_unit: 100
          },
          store_exception_items: [
            {
              products: [],
              store_ids: []
            }
          ]
        }
      }
      this.couponSet.push(obj)
    },
    delCoupon () {

    }
  },
  created () {

  }
}
</script>
<style lang="sass" scoped>
  .un-active
    opacity: .3
</style>



// WEBPACK FOOTER //
// CouponModal.vue?09157ee2